import React, { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";
import {
  Box,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { BaseUrl, endpoints } from "../../utils/factory";
import axios from "axios";

const ProductCard = ({ product, ...rest }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [logData, setLogData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOpen = async (customer) => {
    setOpen(true);
    setLoading(true);
    setLogData(null);
    const clientid = localStorage.getItem("trans-userId");
    const cmp_id = localStorage.getItem("trans-cmp_id");
    try {
      const response = await axios.post(
        `${BaseUrl}${endpoints.getNoificationCount}`,
        {
          userid: clientid,
          qtype: "8",
          searchtext: customer?.itd_id,
          fdate: "",
          tdate: "",
          cmp_id: cmp_id,
        }
      );

      console.log("*******************1", response.data?.recordset);
      if (response.data?.recordset?.length > 0) {
        const userdata = response.data.recordset;
        setLogData(userdata);
      } else {
        setLogData([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("API error", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setLogData(null);
  };

  const handleBack = () => {
    navigate("/app/delivery-list", { replace: true });
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
      {...rest}
    >
      <CardContent>
        <Box sx={{ minWidth: 1350 }}>
          <ArrowLeft onClick={handleBack} style={{ cursor: "pointer" }} />
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell>Sno</TableCell>
                <TableCell>Comment</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Detail Info</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {product.map((customer, index) => (
                <TableRow hover key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{customer.Comments}</TableCell>
                  <TableCell>{customer.date}</TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleOpen(customer)}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </CardContent>

      {/* Popup Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Logs</DialogTitle>
        <DialogContent>
          {loading && <CircularProgress />}
          {!loading && logData && (
            <div
              style={{
                padding: "16px",
                whiteSpace: "pre-wrap", // preserve line breaks but wrap long text
                wordBreak: "break-word", // break very long words
                maxHeight: "400px", // optional: make it scrollable if too tall
                overflowY: "auto",
              }}
            >
              {logData[0]?.comment}
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

ProductCard.propTypes = {
  product: PropTypes.array.isRequired,
};

export default ProductCard;
